import { Injectable } from '@angular/core';

import { Ledger } from '../../models/ledger';

import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class LedgerService {
  url: string = 'ledgers';

  constructor(private httpClient: HttpClientService) {}

  createAdjustments(ledgerAdjustments: Array<Ledger>) {
    return this.httpClient.post(`${this.url}.json`, { add_adjustments: true, ledger_adjustments: ledgerAdjustments });
  }

  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params)
  }

  getSearchOptions(params: any = {}): Promise<any> {
    params.search_options = true;
    return this.httpClient.get(`${this.url}.json`, params);
  }
}
